/// <reference path="../types/index.d.ts" />

import '../client_forms/boldamerican/style.css';
import FormStructure from './boldamerican/form_structure';

export default FormStructure;